import { track } from "@amplitude/analytics-react-native";
import { useMemo } from "react";
import { View } from "react-native";
import ShareMenu from "src/components/ShareMenu";
import { SharePayload } from "src/components/ShareMenu/types";
import { paddingMedium } from "src/styles/spacing";

const RecapUrlShareContent = ({
	url,
	trackingIdentifier,
}: {
	url: string;
	trackingIdentifier: string | undefined;
}) => {
	const data = useMemo<SharePayload[]>(() => {
		return [
			{
				type: "Url",
				url,
			},
		];
	}, [url]);

	return (
		<View
			style={{
				marginTop: paddingMedium,
				width: "100%",
				alignItems: "center",
				overflow: "hidden",
			}}
		>
			<ShareMenu
				data={data}
				onComplete={() => {
					track("recap_share_complete", {
						trackingIdentifier,
					});
				}}
				onSuccess={() => {
					track("recap_share_success", {
						trackingIdentifier,
					});
				}}
			/>
		</View>
	);
};
export default RecapUrlShareContent;
